var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignment2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.627,
    height: 26.552,
    viewBox: "0 0 19.627 26.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assignment",
    transform: "translate(-7.669 -1.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16244",
    "data-name": "Path 16244",
    d: "M75.4,21.95q0,5.127,0,10.256a2.856,2.856,0,0,1-1.974,2.857,2.775,2.775,0,0,1-.848.14c-4.653.009-9.306.017-13.959,0A2.818,2.818,0,0,1,55.82,32.81a3.64,3.64,0,0,1-.04-.647c0-6.818.011-13.638-.011-20.456A2.945,2.945,0,0,1,58.185,8.7a2.516,2.516,0,0,1,.4-.033c4.662,0,9.325-.012,13.986,0a2.815,2.815,0,0,1,2.782,2.4,4.119,4.119,0,0,1,.038.7q0,5.087,0,10.174Zm-1.15,0V11.719a1.741,1.741,0,0,0-1.893-1.907H58.827a1.743,1.743,0,0,0-1.9,1.9V32.168a1.744,1.744,0,0,0,1.906,1.894h13.5a1.746,1.746,0,0,0,1.913-1.915Z",
    transform: "translate(-48.101 -7.47)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16246",
    "data-name": "Path 16246",
    d: "M116.553,210.62a2.3,2.3,0,0,1-4.449.8.323.323,0,0,0-.367-.248q-3.53.011-7.061,0a1.708,1.708,0,0,1-.375-.03.568.568,0,0,1,.019-1.107,1.705,1.705,0,0,1,.349-.025q3.517,0,7.034,0c.21,0,.325-.034.411-.265a2.3,2.3,0,0,1,4.44.867Zm-3.444-.033a1.121,1.121,0,0,0,1.133,1.156,1.147,1.147,0,1,0,.018-2.294A1.123,1.123,0,0,0,113.11,210.587Z",
    transform: "translate(-92.724 -192.666)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16247",
    "data-name": "Path 16247",
    d: "M146.674,76.889l4.062-4.043a2.854,2.854,0,0,1,.235-.224.564.564,0,0,1,.763.035.58.58,0,0,1,.051.764,1.9,1.9,0,0,1-.184.2l-4.342,4.344c-.408.408-.684.406-1.1-.009-.7-.695-1.4-1.383-2.078-2.092a.975.975,0,0,1-.241-.539.477.477,0,0,1,.364-.484.585.585,0,0,1,.643.163c.5.5.995,1,1.488,1.5.12.121.224.258.338.39Z",
    transform: "translate(-129.804 -66.685)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16248",
    "data-name": "Path 16248",
    d: "M107.2,296.212c.938,0,1.876,0,2.814,0a.575.575,0,1,1,.007,1.146c-.514.005-1.028,0-1.543,0-1.362,0-2.724.006-4.085-.008a.936.936,0,0,1-.512-.182.491.491,0,0,1-.124-.595.513.513,0,0,1,.494-.359c.433-.008.866-.006,1.3-.007h1.65Z",
    transform: "translate(-92.573 -274.234)",
    fill: "#11a377"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment2);
export default __webpack_public_path__ + "static/media/assignment2.3012320c74aee3ffbf5f86c517f62d70.svg";
export { ForwardRef as ReactComponent };